import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../constants';

import { displayableCashback, renderPluralConditional } from '../../services/partner/utils';

import SvgComponent from '../SvgComponent';

import './DiscountListComponent.scss';

const Discount = ({ discount, textRefund, showArrow }) => {
    const renderCashback = cashback => (
        <span className="value">
            {`${displayableCashback(cashback.percent, cashback.fixed)} ${renderPluralConditional(
                textRefund,
                () => cashback && (cashback.fixed > 1 || cashback.percent > 1)
            )}`}
        </span>
    );

    const renderWording = () => {
        if (discount.label) {
            return ` ${discount.label}`;
        }
    };

    return (
        !isEmpty(discount) && (
            <li className="discount">
                {showArrow && (
                    <SvgComponent src={`${STATIC_ROOT}/fleche.svg`} width="6" height="10" />
                )}
                {renderCashback(discount.cashback)}
                {renderWording()}
            </li>
        )
    );
};

const mapStoreToProps = state => ({ REFUND: state.i18n.feature.partenaire.rembourse });

export const DiscountListComponent = connect(mapStoreToProps)(
    ({ discounts, REFUND, showArrow = false }) => {
        if (discounts && discounts.length > 0) {
            return (
                <ul className="discounts">
                    {discounts.map(discount => (
                        <Discount
                            key={discount.id}
                            discount={discount}
                            textRefund={REFUND}
                            showArrow={showArrow}
                        />
                    ))}
                </ul>
            );
        }
        return null;
    }
);



// WEBPACK FOOTER //
// ./src/components/discount/DiscountListComponent.js